import type { ReactNode } from 'react'

interface ChartLegendProps {
    series: Array<{ key: string, label: string, color: string }>
}

const ChartLegend = ({ series }: ChartLegendProps): ReactNode => {
    return (
        <ul className='flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-muted-foreground'>
            {series.map(item => (
                <li key={item.key} className='flex items-center gap-1.5'>
                    <span className='size-2.5 rounded-[3px] print-exact' style={{ background: item.color }} aria-hidden='true' />
                    {item.label}
                </li>
            ))}
        </ul>
    )
}

export default ChartLegend
